import { generateAssistantResponse } from './openai-assistant';
import { replaceSnippets } from './prompt-snippets';
import { toast } from './toast';

export { generateAssistantResponse } from './openai-assistant';

export async function generateAIRecommendations(prompt: string): Promise<string> {
  try {
    if (!prompt.trim()) {
      throw new Error('No prompt provided');
    }

    // Replace snippets in the prompt with actual data
    const processedPrompt = replaceSnippets(prompt);
    
    // Validate processed prompt
    if (!processedPrompt || processedPrompt.trim() === '') {
      throw new Error('Processed prompt is empty');
    }

    // Log the actual prompt being sent
    console.log('Processed prompt:', processedPrompt);

    // Use the assistant API
    const response = await generateAssistantResponse([
      {
        role: 'user',
        content: processedPrompt
      }
    ]);

    return response;

  } catch (error) {
    console.error('Error generating AI recommendations:', error);
    toast.error(error instanceof Error ? error.message : 'Failed to generate AI recommendations');
    throw error;
  }
}